export default function ($translate) {
    return {
        KEYS: {
            AUTOMATIC: 'AUTOMATIC',
            MANUAL: 'MANUAL'
        },
        LABELS: {
            AUTOMATIC: $translate.instant('planningGroup.Automatic'),
            MANUAL: $translate.instant('planningGroup.Manual')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/automated/planning/group/type/index.js